/** SEO CrushShy — pages publiques loranrix.com/crushshy/* */
export const CRUSHSHY_SITE = 'https://loranrix.com';

export const crushshySeo = {
  landing: {
    path: '/crushshy',
    title: 'CrushShy — Rencontres à proximité, crush mutuel avant message',
    description:
      'CrushShy : carte live, profils autour de toi, crush réciproque obligatoire avant de discuter. App de rencontre respectueuse (18+), proximité GPS et Bluetooth anonyme.',
    keywords:
      'CrushShy, rencontre proximité, app dating, crush mutuel, carte live, rencontre géolocalisée, match, messages après match',
  },
  privacy: {
    path: '/crushshy/privacy',
    title: 'Politique de confidentialité — CrushShy',
    description:
      'Données collectées par CrushShy (profil, mode live, crush, messages), droits RGPD : export et suppression depuis l’app.',
  },
  terms: {
    path: '/crushshy/terms',
    title: "Conditions d'utilisation — CrushShy",
    description:
      "Règles CrushShy : 18+, crush mutuel pour messagerie, comportement respectueux, modération des signalements.",
  },
  invite: {
    path: '/crushshy/invite',
    title: 'Invitation CrushShy — Rejoins-moi sur l’app',
    description:
      'Tu as reçu une invitation CrushShy. Télécharge l’app, crée ton profil et entre le code parrain pour rejoindre tes amis à proximité.',
  },
};

export function crushshyCanonical(path) {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${CRUSHSHY_SITE}${p}`;
}
